import React from "react";
import { intro } from "../../../../data/mutualFundSeoPage";
import style from "../mfseo.module.css";

const Intro = () => (
  <div>
    <h1 className={style.heading1}>Mutual Funds</h1>
    {intro.map(content => {
      if (typeof content === "string")
        return <p className={style.greyText}>{content}</p>;
      else
        return content.map(point => {
          return <li>{point}</li>;
        });
    })}
  </div>
);

export default Intro;
